import { forwardRef, MotionBox } from '@/ui';

type Props = {
  x: number;
  y: number;
  size: number;
  filled: boolean;
  fillColor: string;
  rotation: number;
};

export const Star = forwardRef(
  ({ x, y, size, filled, fillColor, rotation }: Props, ref) => {
    return (
      <MotionBox
        animate={{ opacity: 1 }}
        boxSize={`${size}px`}
        exit={{ opacity: 0 }}
        initial={{ opacity: 0 }}
        left={`${x}px`}
        pos="absolute"
        ref={ref}
        top={`${y}px`}
        transform={`rotate(${rotation}deg)`}
        transition={{ duration: 0.5 }}
      >
        <svg
          height={size}
          rotate={rotation}
          viewBox="0 0 37 32"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M19.31 1.77888C19.31 9.34288 26.63 15.5018 35.62 15.5018C36.17 15.5018 36.62 15.8804 36.62 16.3432C36.62 16.8059 36.17 17.1845 35.62 17.1845C26.63 17.1845 19.31 23.3434 19.31 30.9074C19.31 31.3702 18.86 31.7488 18.31 31.7488C17.76 31.7488 17.31 31.3702 17.31 30.9074C17.31 23.3434 9.99 17.1845 1 17.1845C0.45 17.1845 0 16.8059 0 16.3432C0 15.8804 0.45 15.5018 1 15.5018C9.99 15.5018 17.31 9.34288 17.31 1.77888C17.31 1.31612 17.76 0.9375 18.31 0.9375C18.86 0.9375 19.31 1.31612 19.31 1.77888Z"
            fill={filled ? fillColor : 'none'}
            stroke={fillColor}
            strokeWidth={filled ? 0 : 2}
          />
        </svg>
      </MotionBox>
    );
  }
);
